<template>
  <div class="default-empty-state">
    <div v-if="$slots.icon" class="default-empty-state__icon">
      <slot name="icon" />
    </div>
    <OwnType :text="message" color="tertiary" variant="paragraph-regular" />
  </div>
</template>

<script lang="ts" setup>
import { OwnType } from '@/ui/OwnType'

defineProps<{
  message: string
}>()
</script>

<style lang="scss" scoped>
.default-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px 24px;

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background-color: var(--background-secondary);
    color: var(--text-color-tertiary);
  }
}
</style>
